import { Link } from 'react-router-dom';
import { Shield } from 'lucide-react';
import { timeAgo } from './format';

const KYC = {
  approved: { label: 'Verified', cls: 'bg-emerald-500/15 text-emerald-400' },
  pending: { label: 'Under review', cls: 'bg-amber-500/15 text-amber-400' },
  rejected: { label: 'Rejected', cls: 'bg-red-500/15 text-red-400' },
  not_submitted: { label: 'Not submitted', cls: 'bg-gray-700/40 text-gray-300' },
};

const Row = ({ label, children, testid }) => (
  <div className="flex items-center justify-between gap-3 p-3 bg-gray-900/30 rounded-lg" data-testid={testid}>
    <span className="text-sm text-gray-300">{label}</span>
    {children}
  </div>
);

export const SecurityCard = ({ security }) => {
  const kyc = KYC[security.kyc_status] || KYC.not_submitted;
  return (
    <div className="glow-card p-6 rounded-xl" data-testid="profile-security-card">
      <div className="flex items-center gap-3 mb-6">
        <Shield className="h-6 w-6 text-teal-400" />
        <h3 className="text-xl font-bold">Account Security</h3>
      </div>
      <div className="space-y-3">
        <Row label="KYC Status" testid="profile-security-kyc">
          {security.kyc_status === 'approved' || security.kyc_status === 'pending'
            ? <span className={`px-3 py-1 rounded-full text-xs font-bold ${kyc.cls}`}>{kyc.label}</span>
            : <Link to="/kyc" className={`px-3 py-1 rounded-full text-xs font-bold ${kyc.cls} hover:ring-1 hover:ring-purple-400`}>{kyc.label} · Verify</Link>}
        </Row>
        <Row label="Last login" testid="profile-security-last-login">
          <span className="text-xs text-gray-400">{security.last_login_at ? timeAgo(security.last_login_at) : '—'}</span>
        </Row>
        <Row label="Total sign-ins" testid="profile-security-logins">
          <span className="text-xs text-gray-400">{security.login_count}</span>
        </Row>
        <Row label="Password" testid="profile-security-password">
          <Link to="/settings" className="text-xs text-purple-400 hover:text-purple-300">
            {security.password_changed_at ? `Changed ${timeAgo(security.password_changed_at)}` : 'Change password'}
          </Link>
        </Row>
      </div>
    </div>
  );
};

export default SecurityCard;
